<div class="container text-center">
  <div class="wrapper">
    @if (!isForcedLogout) {
      <h3>
        You have signed out of {{ appName }}.
      </h3>
    }
    @if ( isForcedLogout) {
      <h3>
        Your {{ appName }} application session has expired. For security
        reasons you will need to sign in again.
      </h3>
    }
    <p class="message">
      To protect your sensitive information we recommend that you close your browser.
    </p>
    @if (isLoggedOut$ | async) {
      <button color="primary" id="signin-button" mat-raised-button
      type="button" (click)="login()">Sign In</button>
    }
  </div>
</div>
